<template>
  <v-tooltip left
             tag="div"
             max-width="350px"
             content-class="Tooltip__Grey Tooltip__Opacity-1">
    <template v-slot:activator="{ on, attrs }">
      <EmailDeliverabilityStatus :status="status"
                                 :block="block"
                                 v-bind="attrs"
                                 v-on="on">
      </EmailDeliverabilityStatus>
    </template>
    <div>
      <div class="font-weight-bold text-uppercase">
        {{ statusObject.tooltip }}
      </div>
      <div v-if="statusObject.description">
        {{ statusObject.description }}
      </div>
    </div>
  </v-tooltip>
</template>
<script>
import neverbounceService from '../../../services/neverbounceService';
import EmailDeliverabilityStatus from './EmailDeliverabilityStatus.vue';

export default {
  components: {EmailDeliverabilityStatus},
  props: {
    status: {
      type: String,
      required: true,
    },
    block: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      statusCodes: neverbounceService.getStatusCodes(),
    }
  },
  computed: {
    statusObject() {
      return neverbounceService.getStatusCode(this.status);
    },
  }
}
</script>
